export const ADMIT_TABLE_HEADERS = {
  main: [
    { key: 'rank', label: 'Academic Rank' },
    { key: 'admits', label: 'PY Admits' },
    { key: 'increase', label: '% Increase' },
    { key: 'target', label: 'Admit Target' },
    { key: 'yield', label: '% Yield' },
  ],
  yield: [
    { key: 'pyYield', label: 'PY Yield' },
    { key: 'projYield', label: 'Proj Yield' },
  ],
  summary: [
    { key: 'pyYield', label: 'PY Yield' },
    { key: 'projYield', label: 'Proj Yield' },
  ],
};

export const YIELD_STYLES = {
  default: 'bg-gray-100 text-gray-600',
  positive: 'bg-green-100 text-green-800',
  negative: 'bg-red-100 text-red-800',
}; 